var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLikeActive = function SvgLikeActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 125,
    viewBox: "0 0 100 125",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7995 63.33C84.8795 66.12 85.1395 70.69 80.9195 74.5C81.1295 75.9 81.1595 78.17 79.8895 80.44C78.2595 83.38 75.0395 85.37 70.3295 86.38C68.3195 86.8 65.9095 87.02 63.1295 87.02C61.5195 87.02 59.7795 86.95 57.9295 86.8C47.6595 87.01 37.6395 85.72 37.2195 85.66C37.1995 85.66 37.1895 85.66 37.1795 85.66L33.6495 85.12C32.5895 85.93 31.2695 86.42 29.8295 86.42H20.3495C16.8595 86.42 14.0195 83.58 14.0195 80.09V54.83C14.0195 51.34 16.8595 48.51 20.3495 48.51H29.8295C30.9795 48.51 32.0495 48.82 32.9795 49.35C33.6195 47.9 34.5895 46.21 36.0495 44.67C36.1195 44.6 36.1995 44.53 36.2795 44.47C41.1895 40.7 46.9695 27.13 49.0095 21.64C48.8195 20.1 48.5795 16.29 50.2795 14.3C51.0195 13.44 52.0195 12.98 53.1695 12.98C54.3495 12.98 58.4195 13.25 60.9595 16.76C63.3795 20.11 63.4995 25.13 61.3395 31.71C59.3995 37.59 59.3095 40.04 59.4095 40.95C60.3095 40.75 61.1795 40.57 62.0095 40.43C62.0195 40.43 62.0195 40.42 62.0295 40.42C63.4895 40.09 76.5195 37.36 82.0295 42.4C85.3895 45.47 84.9495 49.41 83.9295 51.89C84.7895 53 85.8795 54.87 85.9695 57.21C86.0595 59.34 85.3295 61.4 83.7995 63.33ZM29.8295 82.5C31.1595 82.5 32.2495 81.42 32.2495 80.09V54.83C32.2495 54.69 32.2295 54.55 32.1995 54.42C32.0095 54.15 31.8895 53.84 31.8495 53.51C31.4195 52.85 30.6695 52.42 29.8295 52.42H20.3495C19.0195 52.42 17.9395 53.5 17.9395 54.83V80.09C17.9395 81.42 19.0195 82.5 20.3495 82.5H29.8295ZM82.0595 57.4C81.9895 55.24 80.2895 53.66 80.2795 53.64C79.5795 53 79.4295 51.93 79.9395 51.13C80.1495 50.79 81.9795 47.66 79.3895 45.28C76.0195 42.21 66.2795 43.5 62.9795 44.22C62.9195 44.24 62.8495 44.25 62.7895 44.26C61.9295 44.41 61.0095 44.6 60.0695 44.82C59.1095 45.17 57.7995 45.12 56.8095 44.24C54.7895 42.44 55.0295 38.33 57.6195 30.48C59.3495 25.24 59.3995 21.29 57.7895 19.06C56.3695 17.09 53.9895 16.9 53.2095 16.89C52.7995 17.45 52.6595 19.73 52.9495 21.56C52.9995 21.89 52.9595 22.22 52.8495 22.53C52.5595 23.33 45.7395 41.98 38.7895 47.47C36.9495 49.46 36.1495 51.8 35.8595 52.91C36.0495 53.52 36.1595 54.16 36.1595 54.83V80.09C36.1595 80.58 36.0995 81.06 35.9895 81.52L37.7395 81.79C38.2395 81.85 48.1495 83.09 57.9495 82.89C58.0095 82.89 58.0795 82.89 58.1395 82.89C62.8595 83.27 66.6795 83.15 69.5195 82.55C73.0395 81.8 75.3795 80.46 76.4495 78.58C77.6095 76.55 76.9295 74.48 76.8995 74.39C76.6095 73.59 76.8895 72.7 77.5695 72.19C82.2995 68.63 80.0795 64.48 79.8095 64.02C79.3495 63.26 79.4595 62.3 80.0695 61.66C81.4395 60.24 82.1095 58.8 82.0595 57.4Z",
    fill: "var(--svg-color, #D5158C)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 49,
    width: 41,
    height: 35,
    fill: "var(--svg-color, #D5158C)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 43,
    width: 6,
    height: 30,
    fill: "var(--svg-color, #D5158C)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 71,
    width: 3,
    height: 9,
    fill: "var(--svg-color, #D5158C)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 44,
    width: 41,
    height: 6,
    fill: "var(--svg-color, #D5158C)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 43,
    width: 12,
    height: 1,
    fill: "var(--svg-color, #D5158C)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 16,
    width: 7,
    height: 21,
    fill: "var(--svg-color, #D5158C)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 37,
    width: 15,
    height: 8,
    fill: "var(--svg-color, #D5158C)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 24,
    width: 5,
    height: 5,
    fill: "var(--svg-color, #D5158C)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 32,
    width: 6,
    height: 6,
    fill: "var(--svg-color, #D5158C)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 29,
    width: 5,
    height: 4,
    fill: "var(--svg-color, #D5158C)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 56,
    width: 2,
    height: 3,
    fill: "var(--svg-color, #D5158C)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLikeActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/like-active.f33f35e9.svg";
export { ForwardRef as ReactComponent };